<template>
    <div class="jr-component" :style="'height: 100%; width: ' + tableWidthAll + 'px; position:relative;'">
    <!-- <div class="jr-component" :style="'height: ' + tableHeight + 'px; width: ' + tableWidthAll + 'px; position:relative;'"> -->

          <pl-table v-bind="$attrs" :id="components.tableId" 
                    @header-dragend="headerDragend"
                    @handlePageSize="handlePageSize"
                    @sort-change="sortChange"
                    @cell-click="cellClick"
                    :data="datas"
                    :ref="components.tableId"
                    :big-data-checkbox="true"
                    :fixed-columns-roll="true"
                    :size="size"
                    :show-summary="showSummary"
                    :use-virtual="true"
                    :cell-class-name="cellClass"
                    :row-class-name="rowClass"           
                    :height="tableHeight"              
                    :summary-method="components.tableSumtype == 'Client' ? null : getSummaries"
                    :total-option="components.tableSumOptions"                    
                    

                    :pagination-show="pagination"
                    :current-page="queryLimit.offset+1"
                    :pt-total="pageTotal.count"
                    :page-sizes="[100, 500, 1000, 3000, 5000, 10000]"
                    :page-size="components.tablePagesize"
                    :row-height="30">
            <template slot="empty">没有符合条件的记录</template>            
            <pl-table-column :key="0" v-if="selection" type="selection" width="50"/>
            <pl-table-column :key="1" v-if="index" type="index" width="50" :show-overflow-tooltip="true"/>
            <template v-for="(item, i) in components.tableColumns">
              <pl-table-column v-if="item.columnType != 'Date' && item.columnType != 'Datetime' && item.columnType != 'Select' && item.columnVisible"
              :key="i+2"
              :sortable="sortable"
              :show-overflow-tooltip="true"
              :resizable="true"
              :prop="item.columnName"
              :label="item.columnDisplayname"
              :width="item.columnWidth"/>  
              <pl-table-column v-if="item.columnType == 'Select' && item.columnVisible"
              :key="i+2"
              :sortable="sortable"
              :show-overflow-tooltip="true"
              :resizable="true"
              :prop="item.columnName"
              :label="item.columnDisplayname"
              :width="item.columnWidth"
              :formatter="selectColumnFormat">   
              </pl-table-column>
              <pl-table-column v-if="item.columnType == 'Date' && item.columnVisible"
              :key="i+2"
              :sortable="sortable"
              :show-overflow-tooltip="true"
              :resizable="true"
              :prop="item.columnName"
              :label="item.columnDisplayname"
              :width="item.columnWidth"
              /> 
              <pl-table-column v-if="item.columnType == 'Datetime' && item.columnVisible"
              :key="i+2"
              :sortable="sortable"
              :show-overflow-tooltip="true"
              :resizable="true"
              :prop="item.columnName"
              :label="item.columnDisplayname"
              :width="item.columnWidth"
              /> 
            </template>
          </pl-table>
          <el-row align="middle" justify="center" class="jr-bigtable-badge">
            <el-dropdown size="mini" split-button type="primary" @click="exportExcel(false)" trigger="click" title="导出当前页" >
              <i class="el-icon-download"></i>导出本页
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="exportExcel(true)" icon="el-icon-document-add">导出全部</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-button @click="tt(false)" type="primary" size="mini" icon="el-icon-download" title="导出数据">导出</el-button>             -->
            <el-button @click="bigtableVisible = true" size="mini" type="success" icon="el-icon-setting" circle title="表格设置"></el-button>
          </el-row>
          <el-dialog title="表格参数配置" :visible.sync="bigtableVisible" :close-on-click-modal="false" width="500px">
            <div style="height: 400px; overflow-y: scroll;">
              <div style="height: 70px;">
                <div style="width: 95%; display: flex; flex-direction: row ; align-items: center;">
                  <b style="width: 156px; text-align: left;">默认排序范围:</b> 
                  <b style="width: 156px; text-align: left;">默认合计范围:</b>
                  <b style="width: 120px; text-align: left;">默认每页条数:</b>                
                </div>
                <div style="width: 95%; display: flex; flex-direction: row ; align-items: center; justify-content: space-between">
                  <el-select v-model="components.tableSorttype" size="mini" placeholder="请选择" style="width: 130px;">
                    <el-option key="0" label="当前页（推荐）" value="Client"></el-option>
                    <el-option key="1" label="所有页" value="Server"></el-option>
                  </el-select>
                  <el-select v-model="components.tableSumtype" size="mini" placeholder="请选择" style="width: 130px;">
                    <el-option key="0" label="当前页（推荐）" value="Client"></el-option>
                    <el-option key="1" label="所有页" value="Server"></el-option>
                  </el-select>
                  <el-select @change="settingPageSizeChange" v-model="components.tablePagesize" size="mini" placeholder="请选择" style="width: 120px;">
                    <el-option v-for="item in setTableDefaultSize" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div style="width: 95%; display: flex; flex-direction: row ; align-items: center;">
                <b style="width: 200px; text-align: left;">列名</b> 
                <b style="width: 120px; text-align: left;">是否可见</b>
                <b style="width: 120px; text-align: left;">列宽</b>
                <b style="width: 40px; text-align: left;">顺序</b>
              </div>
              <hr>
              <transition-group tag="div" class="container">
                <div class="jr-bigtable-column-item" v-for="(item, i) in components.tableColumns" v-bind:key="item.columnId"  :draggable="draggable" 
                @dragstart="handleDragStart($event, item)"
                @dragover.prevent="handleDragOver($event, item)"  
                @dragend="handleDragEnd($event, item)" 
                @dragenter="handleDragEnter($event, item)">
                  <p style="width: 150px;">{{item.columnDisplayname + '：'}}</p> 
                  <el-checkbox v-model="item.columnVisible" style="text-align: left;">是否可见</el-checkbox>
                  <el-input style="width: 80px;" v-model="item.columnWidth" placeholder="宽度" :minlength="50" :maxlength="500" size="small" ></el-input>
                  <i @mousedown="draggable = true" @mouseleave="draggable = false" class="el-icon-s-operation jr-bigtable-setting-move"></i>
                </div>
              </transition-group>
            </div>
            <span slot="footer" class="dialog-footer">
              <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                <el-button @click="rollBackTableSetting" :loading="queryLoding" type="warning">还原默认值</el-button>
                <div>
                  <el-button @click="bigtableVisible = false">取 消</el-button>
                  <el-button type="primary" :loading="saveLoding" @click="saveTableSetting">保 存</el-button>
                </div>
              </div>
            </span>
          </el-dialog>
    </div>
</template>
<script>
import store from '@/store'
import JRGLOBAL from '@/api/jrglobal'
import { rollBackTableSetting, saveTableSetting, queryExport, downLoadExcel } from '@/api/public'
import { Notification } from "element-ui"
export default {
  name: 'JrBigtable',
  data() {
    return {
      // 性别
      sex: JRGLOBAL.sex,
      // 是否
      yesOrno: JRGLOBAL.yesOrno,
      // 是否有效
      existsType: JRGLOBAL.existsType,
      bigtableVisible: false,
      columnDataProps: {},
      tableHeight: 700,
      tableWidth: 1424,
      draggable: false,
      queryLoding: false,
      saveLoding: false,
      datas: [],
      //getSummariess: false,
      setTableDefaultSize: [{
          value: 100,
          label: '100条/页'
        }, {
          value: 500,
          label: '500条/页'
        }, {
          value: 1000,
          label: '1000条/页'
        }, {
          value: 3000,
          label: '3000条/页'
        }, {
          value: 5000,
          label: '5000条/页'
        }, {
          value: 10000,
          label: '10000条/页'
        }]      
    }
  },
  watch: {
    tableData(){
      this.$refs[this.components.tableId].$children[0].bodyWrapper.scrollTop = 0
      this.timer = setTimeout(()=>{   //设置延迟执行
        this.datas = this.tableData
      },200);      
    },
    
  },
  computed: {
    columnDataProp() {
      let columnDataProp = {}
      this.components.tableColumns.forEach(item=>{       
        columnDataProp[item.columnName] = item
      })
      return columnDataProp
    },
    tableWidthAll() {
      return this.tableWidth + store.getters.MenuWidth
    },
    queryLimit() {
      let limit = {
        table: "",
        sort: "",
        order: "asc",
        offset: 0,
        limit: this.components.tablePagesize
      }
      return limit
    },
    sortable() {
      if(this.components.tableSorttype == "Server"){
        return 'custom'
      }else{
        return true
      }
      
    }
  },
  mounted() {
    var that=this;
    window.addEventListener("resize", function(){
      const ob = that.$refs[that.components.tableId].$el.getBoundingClientRect()
      that.tableWidth = window.innerWidth-ob.left -40
      that.tableHeight = window.innerHeight-ob.top -35
    })
    setTimeout(() => {
      const ob = that.$refs[that.components.tableId].$el.getBoundingClientRect()
      that.tableWidth = window.innerWidth-ob.left -40
      that.tableHeight = window.innerHeight-ob.top-35
    },200)
  },
  props: {
    value: {},
    components: {},
    size: {
      type: String,
      default: 'mini'
    },
    // 是否启用多选
    selection: {
      type: Boolean,
      default: true
    },
    // 是否显示行号
    index: {
      type: Boolean,
      default: true
    },  
    // 数据对象
    tableData: {},
    // 是否显示汇总行
    showSummary: {
      type: Boolean,
      default: true
    },
    // 会总行数据，只有启用后台汇总的时候才使用
    summaryData: {},
    // 是否显示分页器
    pagination: {
      type: Boolean,
      default: true
    },
    // 汇总行数据相关，包含总行数count
    pageTotal: {},
    // 当前的查询条件信息
    queryParam: {}
    
  },
  methods: {
    // 表格设置中的选择默认记录数事件
    settingPageSizeChange(e) {
      this.components.tablePagesize = e
      this.$emit('sort-change', this.queryLimit, 'None')
    },
    // 表格翻页事件
    handlePageSize(page) {
      if(this.components.tablePagesize != page.size){
        this.queryLimit.offset = 0  
        this.components.tablePagesize = page.size
      }else{
        this.queryLimit.offset = page.page-1
      }      
      this.$emit('sort-change', this.queryLimit, 'Auto')
    },
    // 表格排序事件
    sortChange(column, prop, order ) {
      if(column.order != null){
        this.queryLimit.sort = column.prop
        this.queryLimit.order = column.order
        for(var key in this.components.tableColumns){
          if(this.components.tableColumns[key].columnName == column.prop){
            this.queryLimit.table = this.components.tableColumns[key].columnDbtable
            break
          }
        }
      }else{
        this.queryLimit.sort = ''
      }
      if(this.components.tableSorttype == 'Server' && this.tableData.length > 0){
        this.$emit('sort-change', this.queryLimit, 'Auto')
      }
      
    },
    //单元格点击事件(主键)
    cellClick(row, column, cell, event) {
      if(this.columnDataProp[column.property] !== undefined && this.columnDataProp[column.property].columnPrimary){
        var primaryId = row[column.property]
        this.$emit('cell-click', this.components.tableId, primaryId)
      }
    },
    // 时间戳转日期Data
    dataFormat(row, column, cellValue, index) {
      var dateVal = cellValue + "";
      if (cellValue != null) {
          var date = new Date(parseInt(dateVal.replace("/Date(", "").replace(")/", ""), 10));
          var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
          var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
          var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
          var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
          var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
          return date.getFullYear() + "-" + month + "-" + currentDate ;
      }else{
        return ''
      }
    },
    // 时间戳转日期DataTime
    datatimeFormat(row, column, cellValue, index) {
      var dateVal = cellValue + "";
      if (cellValue != null) {
          var date = new Date(parseInt(dateVal.replace("/Date(", "").replace(")/", ""), 10));
          var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
          var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
          var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
          var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
          var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
          return date.getFullYear() + "-" + month + "-" + currentDate + " " + hours + ":" + minutes + ":" + seconds;
      }else{
        return ''
      }
    },
    //select类型列值自动映射
    selectColumnFormat(row, column, cellValue, index) {
      let formatValue = ""
      if(this.columnDataProp[column.property] !== undefined && this.columnDataProp[column.property].columnDatasource == "existsType"){
        formatValue = this.existsType[cellValue]
      }
      return formatValue
    },
    // 单元格样式针对主键设置
    cellClass({row, column, rowIndex, columnIndex}) {
      let classValue = ''
      // 判断是否存在主键列
      if(this.columnDataProp[column.property] !== undefined && this.columnDataProp[column.property].columnPrimary){
        classValue = classValue + ' cellPrimaryClass'
      }
      // 判断是否有删除标志，并且是否为已删除状态
      if(column.delType !== undefined && column.delType){
        classValue = classValue + ' cellDelClass'
      }
      //无效、报警、未完成等样式
      if(this.columnDataProp[column.property] !== undefined && this.columnDataProp[column.property].columnDatasource == "existsType"){
        if(row[column.property]=="0"){
          classValue = classValue + ' cellNoExists'
        }
      }
      
      return classValue
    },
    // 行记录样式针对单据不同状态颜色不同
    rowClass({row, rowIndex}) {
      if(row.verifyType !== undefined && row.verifyType){
        return 'rowVerifyClass'
      }
      return ''
    },
    // 拖拽移动顺序相关
    handleDragStart(e,item){
        this.dragging = item;
    },
    handleDragEnd(e,item){
        this.dragging = null
    },
    //首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver(e) {
        e.dataTransfer.dropEffect = 'move'// e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnter(e,item){
        e.dataTransfer.effectAllowed = "move"//为需要移动的元素设置dragstart事件
        if(item === this.dragging){
            return
        }       
        const newItems = [...this.components.tableColumns]
        const src = newItems.indexOf(this.dragging)
        const dst = newItems.indexOf(item) 
        newItems.splice(dst, 0, ...newItems.splice(src, 1)) 
        this.components.tableColumns = newItems 
        
    },
    // 改变列宽事件，自动更新列宽属性
    headerDragend(newWidth, oldWidth, column, event){
      const columnName = column.property
      for(var key in this.components.tableColumns){
        if(this.components.tableColumns[key].columnName == columnName){
          this.components.tableColumns[key].columnWidth = newWidth
          break
        }
      }
    },
    // 恢复默认值
    rollBackTableSetting() {
      this.queryLoding = true
      rollBackTableSetting(this.components.tableId).then(res => {
        const code = res.status.code    
        if(code == 200){
          const table = res.data.table
          this.components.tableColumns = table[0].tableColumns
          this.components.tablePagesize = table[0].tablePagesize
          this.components.tableSorttype = table[0].tableSorttype
          this.components.tableSumtype = table[0].tableSumtype
          Notification.success({
            title: '成功恢复默认值',
            duration: 1500
          })
        }
        this.queryLoding = false
      })
      .catch(error => {
        this.queryLoding = false
        return Promise.reject('error')
      })
    },
    // 表格求和项方法
    getSummaries(param) {
      const sums = []
      sums[0] = '合计'
      if(this.components.tableSumtype == 'Server'){
        for(var i in param.columns){
          if(i>0){
            sums[i] = ''
            this.components.tableSumOptions.forEach(item=>{
              if(param.columns[i].label == item.label){
                sums[i] = this.pageTotal[param.columns[i].property]
              }
            })  
          }
        }
      }
      return sums
    },
    // 保存表格参数配个
    saveTableSetting() {
      this.saveLoding = true
      saveTableSetting(this.components).then(res => {
        const code = res.status.code    
        if(code == 200){
          Notification.success({
            title: '参数保存成功',
            duration: 1500
          })
        }        
        this.saveLoding = false
      })
      .catch(error => {
        this.saveLoding = false
        return Promise.reject('error')
      })
    },
    // 导出表格
    exportExcel(exportType){
      if(this.tableData.length>0){
        queryExport(this.queryParam, exportType, this.components.tableId).then(res => {
          const content = res.data
          const blob = new Blob([content])//构造一个blob对象来处理数据
          const fileName = decodeURI(res.headers.filename) + '.xlsx'
          //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
          //IE10以上支持blob但是依然不支持download
          if ('download' in document.createElement('a')) { //支持a标签download的浏览器
            const link = document.createElement('a')//创建a标签
            link.download = fileName//a标签添加属性
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()//执行下载
            URL.revokeObjectURL(link.href) //释放url
            document.body.removeChild(link)//释放标签
          } else { //其他浏览器
            navigator.msSaveBlob(blob, fileName)
          }      
        })
        .catch(error => {
          return Promise.reject('error')
        }) 
      }else{
        Notification.warning({
          title: '请先查询数据',
          duration: 1500
        })
      }           
    }
  }
}
</script>
<style scoped lang="scss">  
  .jr-bigtable-badge{
    position:absolute;
    right: 10px;
    top: -35px; 
  }
  .jr-bigtable-setting-move:hover{
    cursor: s-resize;
  }
  .jr-bigtable-column-item{
    transition: all linear .3s; 
    width: 90%; 
    display: flex; 
    flex-direction: row ; 
    justify-content: space-between; 
    align-items: center;
  }

</style>


// WEBPACK FOOTER //
// src/components/componentsjr/JrBigtable.vue